import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "d-none d-lg-block" }
const _hoisted_3 = { class: "d-block d-lg-none" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "container mt-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-4 text-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col col-sm-12 boder-bottom" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Modifier mes informations")
  ])
], -1)
const _hoisted_8 = { class: "row m-2" }
const _hoisted_9 = { class: "col-12 col-lg form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "inputFirstName" }, "Prénom: ", -1)
const _hoisted_11 = { class: "col-12 col-lg form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "inputFirstName" }, "Nom: ", -1)
const _hoisted_13 = { class: "row m-2" }
const _hoisted_14 = { class: "col form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "inputUserName" }, "Pseudo: ", -1)
const _hoisted_16 = { class: "error" }
const _hoisted_17 = { class: "row m-2" }
const _hoisted_18 = { class: "col-12 col-lg-6 form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "inputPhoneNumber" }, "Téléphone: ", -1)
const _hoisted_20 = { class: "row m-2" }
const _hoisted_21 = { class: "col-12 col-lg-4 form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "inputBirthDate" }, "Date de naissance: ", -1)
const _hoisted_23 = { class: "error" }
const _hoisted_24 = { class: "col-12 col-lg-4 form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "inputSex" }, "Sexe: ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "true" }, "Femme", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "false" }, "Homme", -1)
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "row m-2" }
const _hoisted_31 = { class: "col form-group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "inputAddress" }, "Adresse: ", -1)
const _hoisted_33 = { class: "row m-2" }
const _hoisted_34 = { class: "col-12 col-lg-6 form-group" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "inputCity" }, "Ville: ", -1)
const _hoisted_36 = { class: "col-12 col-lg form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "inputZipCode" }, "Code Postal: ", -1)
const _hoisted_38 = { class: "col-12 col-lg form-group" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "inputCountry" }, "Pays: ", -1)
const _hoisted_40 = { class: "row m-2 text-start" }
const _hoisted_41 = { class: "col text-start" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "text-success" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "container mt-5" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-4 text-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col col-sm-12 boder-bottom" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Modifier mon mot de passe")
  ])
], -1)
const _hoisted_47 = { class: "row m-2 mt-4 text-start" }
const _hoisted_48 = { class: "col text-start" }
const _hoisted_49 = { class: "container mt-5" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-4 text-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col col-sm-12 boder-bottom" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Supprimer mon compte")
  ])
], -1)
const _hoisted_51 = { class: "row m-2 mt-4 text-start" }
const _hoisted_52 = { class: "col text-start" }
const _hoisted_53 = { class: "container mt-5" }
const _hoisted_54 = { class: "row m-2 mt-4" }
const _hoisted_55 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_MiniTopBar = _resolveComponent("MiniTopBar")!
  const _component_ChangePassword = _resolveComponent("ChangePassword")!
  const _component_DeleteAccount = _resolveComponent("DeleteAccount")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TopBar, {
        title: _ctx.title,
        userButton: true
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_MiniTopBar, { userButton: true })
    ]),
    _withDirectives(_createVNode(_component_ChangePassword, { onCloseChangePasswordModal: _ctx.toggleChangePasswordModal }, null, 8, ["onCloseChangePasswordModal"]), [
      [_vShow, _ctx.showChangePasswordModal]
    ]),
    _withDirectives(_createVNode(_component_DeleteAccount, { onCloseDeleteAccountModal: _ctx.toggleDeleteAccountModal }, null, 8, ["onCloseDeleteAccountModal"]), [
      [_vShow, _ctx.showDeleteAccountModal]
    ]),
    _withDirectives(_createVNode(_component_Error, { onCloseErrorModal: _ctx.toggleErrorModal }, null, 8, ["onCloseErrorModal"]), [
      [_vShow, _ctx.showErrorModal]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("form", {
            class: "text-start mb-4 fw-bold",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.me.firstName) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputFirstName",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.me.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.me.lastName) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputFirstName",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.me.lastName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.username) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputUserName",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.username]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_16, " Le pseudo choisi n'est pas disponible. Merci d'en choisir un différent. ", 512), [
                  [_vShow, _ctx.duplicatePseudo]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.me.phoneNumber) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputPhoneNumber",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.me.phoneNumber]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.me.dateOfBirth) = $event)),
                  type: "date",
                  class: "form-control",
                  id: "inputBirthDate",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.me.dateOfBirth]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_23, " La date est incorrecte! ", 512), [
                  [_vShow, !_ctx.dateIsCorrect()]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.me.sex) = $event)),
                  "aria-label": "Default select example",
                  required: ""
                }, _hoisted_29, 512), [
                  [_vModelSelect, _ctx.me.sex]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.me.address) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputAddress",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.me.address]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.me.city) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputCity",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.me.city]
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.me.zipCode) = $event)),
                  title: "Le code postal doit contenir une suite de chiffres uniquement",
                  type: "text",
                  class: "form-control",
                  id: "inputZipCode",
                  pattern: "[0-9]*",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.me.zipCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.me.country) = $event)),
                  type: "text",
                  class: "form-control",
                  id: "inputCountry",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.me.country]
                ])
              ])
            ])
          ], 32),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: 
                  !_ctx.dateIsCorrect() || _ctx.duplicatePseudo || _ctx.showErrorModal
                ,
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateUserInfo()))
              }, " Modifier mes informations ", 8, _hoisted_42),
              _withDirectives(_createElementVNode("div", _hoisted_43, " Vos informations ont bien été mises à jour ", 512), [
                [_vShow, _ctx.updateSuccess]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toggleChangePasswordModal && _ctx.toggleChangePasswordModal(...args)))
              }, " Modifier mon mot de passe ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-danger",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toggleDeleteAccountModal && _ctx.toggleDeleteAccountModal(...args)))
              }, " Supprimer mon compte ")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.goBackToDashboard && _ctx.goBackToDashboard(...args)))
          }, " Retour ")
        ])
      ])
    ])
  ]))
}